const defaultSearchConfiguration = {
    _searchable: true,
    productNumber:  { _searchable: true, _score: 500 },
    productName:    { _searchable: true, _score: 300 },
    email:          { _searchable: true, _score: 500 },
    customerNumber: { _searchable: true, _score: 200 },
};

export default defaultSearchConfiguration;
